Object.defineProperty (module.exports, "__esModule", { value: true }),
module.exports.BitmapDataChannel = module.exports.default = {
	ALPHA: 8,
	BLUE: 4,
	GREEN: 2,
	RED: 1
};